
document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver((mutations, obs) => {
    const container = document.querySelector('.device-compatibility-container');
    if (!container) return;

    const typeformBtn = container.querySelector(
      '.tf-v1-button, [data-tf-popup], [data-tf-button] button',
    );

    if (typeformBtn) {
      if (typeformBtn.closest('div')?.classList.contains('esim-checker-desktop')) {
        typeformBtn.innerHTML = `<span>Check if your device is compatible with eSIM </span><svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none">
<path d="M1.5 8H18M18 8L11 1M18 8L11 15" stroke="#0C1924" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`;
      } else {
        const success = typeformBtn.closest('div')?.id === 'check-another-device' || '';
        success
          ? (typeformBtn.textContent = 'Check compatibility for a different device >')
          : (typeformBtn.textContent = 'Check with a quick quiz >');
      }

      obs.disconnect();
    }
  });

  // Start observing the body for dynamically added nodes
  observer.observe(document.body, { childList: true, subtree: true });

  const messageContainer = document.querySelector('.esim-checker');
  const checkingDeviceMsg = document.querySelector('.checker-header');
  const desktopDiv = document.querySelector('.esim-checker-desktop');

  function detectDevice() {
    const userAgent = navigator.userAgent;
    let deviceInfo = {
      brand: 'Unknown',
      model: 'Unknown',
      os: 'Unknown',
      version: 'Unknown',
      isCompatible: false,
      confidence: 'low',
    };

    // Detect iOS devices
    if (/iPhone/.test(userAgent)) {
      deviceInfo.brand = 'Apple';
      deviceInfo.os = 'iOS';

      // Extract iOS version
      const iosVersion = userAgent.match(/Version\/([\d.]+)/);
      if (iosVersion) {
        deviceInfo.version = `${iosVersion[1]}`;
      } else {
        const iosVersionChrome = userAgent.match(/OS (\d+)_(\d+)/);
        if (iosVersionChrome) {
          deviceInfo.version = `${iosVersionChrome[1]}.${iosVersionChrome[2]}`;
        }
      }

      // Detect iPhone model (simplified detection)
      if (/iPhone.*OS 1[2-9]|iPhone.*OS [2-9][0-9]/.test(userAgent)) {
        deviceInfo.model = 'iPhone';
        deviceInfo.isCompatible = true;
        deviceInfo.confidence = 'high';
      } else {
        deviceInfo.model = 'iPhone';
        deviceInfo.confidence = 'medium';
      }
    }

    // Detect Android devices
    else if (/Android/.test(userAgent)) {
      deviceInfo.os = 'Android';

      // Extract Android version
      const androidVersion = userAgent.match(/Android (\d+(?:\.\d+)?)/);
      if (androidVersion) {
        deviceInfo.version = androidVersion[1];
      }

      // Detect Samsung
      if (/Samsung|SM-/.test(userAgent)) {
        deviceInfo.brand = 'Samsung';
        deviceInfo.model = 'Samsung Galaxy';
        // Most newer Samsung devices support eSIM
        if (parseFloat(deviceInfo.version) >= 10) {
          deviceInfo.isCompatible = true;
          deviceInfo.confidence = 'medium';
        }
      }

      // Detect Google Pixel
      else if (/Pixel/.test(userAgent)) {
        deviceInfo.brand = 'Google';
        deviceInfo.model = 'Google Pixel';
        deviceInfo.isCompatible = true;
        deviceInfo.confidence = 'high';
      }

      // Detect OnePlus
      else if (/OnePlus/.test(userAgent)) {
        deviceInfo.brand = 'OnePlus';
        deviceInfo.model = 'OnePlus';
        deviceInfo.isCompatible = true;
        deviceInfo.confidence = 'medium';
      }
    }
    return deviceInfo;
  }

  function compatibilityUnknown() {
    messageContainer.classList.remove('esim-checker-shimmer');
    checkingDeviceMsg.style.display = 'none';
    messageContainer.classList.add('esim-checker-fail');
    messageContainer.querySelector('.fail-header').classList.add('show');
    showTypeformInline(document.getElementById('quick-quiz'), true);
  }

  function compatibilityConfirmed(deviceInfo) {
    messageContainer.classList.remove('esim-checker-shimmer');
    checkingDeviceMsg.style.display = 'none';
    messageContainer.classList.add('esim-checker-success');
    messageContainer.querySelector('.success-header').classList.add('show');
    const deviceSpan = document.getElementById('device');
    deviceSpan.textContent = `${deviceInfo.model}${deviceInfo.version !== 'Unknown' ? ` (${deviceInfo.os} ${deviceInfo.version})` : ''}`;
    showTypeformInline(document.getElementById('check-another-device'), true);
  }

  function checkDeviceCompatibility() {
    const deviceInfo = detectDevice();
    if (!deviceInfo) compatibilityUnknown();
    if (
      deviceInfo.isCompatible === true &&
      (deviceInfo.confidence === 'high' || deviceInfo.confidence === 'medium')
    ) {
      compatibilityConfirmed(deviceInfo);
    } else {
      compatibilityUnknown();
    }
  }

  function desktopCompatibility() {
    showTypeformInline(desktopDiv, true);
  }

  if (desktopDiv && window.innerWidth > 768) {
    desktopCompatibility();
    return;
  }
  checkDeviceCompatibility();
});
